var LOW_VALUE_WORDS = new Set(["cheese", "add", "side", "extra"]);
/*
Provide a simple array of objects with topping name as key for matching.
 */
var RAW_TOPPING_IMAGE_CANDIDATES = [
    //Cheeses
    { key: "bleu cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/bleu+cheese.webp" },
    { key: "blue cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/bleu+cheese.webp" },
    { key: "feta", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/feta.webp" },
    { key: "feta cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/feta.webp" },
    { key: "parmesan", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/parmesan.webp" },
    { key: "parmesan cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/parmesan.webp" },
    { key: "mozzarella", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/mozzarella.webp" },
    { key: "mozzarella cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/mozzarella.webp" },
    { key: "extra cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/mozzarella.webp" },
    { key: "asiago", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/asiago.webp" },
    { key: "cheddar", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/cheddar.webp" },
    { key: "cheddar cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/cheddar.webp" },
    { key: "no cheese", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/cheeses/no cheese.webp" },
    //Vegetables
    { key: "garlic", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/garlic.webp" },
    { key: "green peppers", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/green+peppers.webp" },
    { key: "green olives", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/green+olives.webp" },
    { key: "red onions", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/red+onions.webp" },
    { key: "onions", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/onions.webp" },
    { key: "basil", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/basil.webp" },
    { key: "black olives", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/black+olives.webp" },
    { key: "banana peppers", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/banana+peppers.webp" },
    { key: "cucumber", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/cucumber.webp" },
    { key: "artichokes", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/artichokes.webp" },
    { key: "oregano", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/oregano.webp" },
    { key: "yellow peppers", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/yellow+peppers.webp" },
    { key: "red peppers", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/red+peppers.webp" },
    { key: "zucchini", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/zucchini.webp" },
    { key: "hot giardiniera", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/hot+giardiniera.webp" },
    { key: "tomatoes", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/tomatoes.webp" },
    { key: "mushrooms", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/mushrooms.webp" },
    { key: "pineapple", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/pineapple.webp" },
    { key: "sun dried tomato", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/sun-dried+tomato.webp" },
    { key: "jalapenos", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/jalapenos.webp" },
    { key: "spinach", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/spinach.webp" },
    { key: "lettuce", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/lettuce.webp" },
    { key: "romaine", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/romaine.webp" },
    { key: "Iceberg & Romaine Lettuce Blend", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/Iceberg & Romaine Lettuce Blend.webp" },
    { key: "croutons", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/croutons.webp" },
    { key: "mayo", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/mayo.webp" },
    { key: "pizza sauce", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/pizza+sauce.webp" },
    { key: "ranch", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/vegetables/ranch.webp" },
    //Meats
    { key: "turkey", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/turkey.webp" },
    { key: "prosciutto", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/prosciutto.webp" },
    { key: "chorizo", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/chorizo.webp" },
    { key: "ground beef", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/ground+beef.webp" },
    { key: "sausage", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/sausage.webp" },
    { key: "bacon", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/bacon.webp" },
    { key: "meatballs", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/meatballs.webp" },
    { key: "italian beef", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/italian+beef.webp" },
    { key: "ham", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/ham.webp" },
    { key: "salami", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/salami.webp" },
    { key: "pepperoni", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/pepperoni.webp" },
    { key: "anchovies", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/anchovies.webp" },
    { key: "canadian bacon", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/canadian+bacon.webp" },
    { key: "chicken", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/chicken.webp" },
    { key: "grilled chicken", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/chicken.webp" },
    { key: "breaded chicken", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/breaded+chicken.webp" },
    { key: "steak", src: "https://d2tiuz65ev218l.cloudfront.net/toppings/meats/steak.webp" }
];
function normalizeLabel(value) {
    return value
        .normalize("NFD")
        .split("")
        .filter(function (character) { return character.charCodeAt(0) < 0x0300 || character.charCodeAt(0) > 0x036f; })
        .map(function (character) {
        if (character === "'" || character === "’") {
            return "";
        }
        var lowerCaseCharacter = character.toLowerCase();
        var isLetter = lowerCaseCharacter !== character.toUpperCase();
        var characterCode = character.charCodeAt(0);
        var isNumber = characterCode >= 0x0030 && characterCode <= 0x0039;
        return isLetter || isNumber ? lowerCaseCharacter : " ";
    })
        .join("")
        .split(" ")
        .filter(Boolean)
        .join(" ");
}
/*
Get rid of suffixes to ensure best possible match.
 */
function normalizeWord(word) {
    if (word.length > 3 && word.endsWith("es")) {
        return word.slice(0, -2);
    }
    if (word.length > 2 && word.endsWith("s")) {
        return word.slice(0, -1);
    }
    return word;
}
/*
Filter low value words to avoid words like "cheese" from resulting in higher matches where not appropriate.
 */
function toComparableWords(value) {
    return normalizeLabel(value)
        .split(" ")
        .filter(Boolean)
        .map(function (word) { return normalizeWord(word); })
        .filter(function (word) { return !LOW_VALUE_WORDS.has(word); });
}
var TOPPING_IMAGE_CANDIDATES = RAW_TOPPING_IMAGE_CANDIDATES.map(function (candidate) {
    var comparableWords = toComparableWords(candidate.key);
    return {
        src: candidate.src,
        normalizedKey: normalizeLabel(candidate.key),
        comparableWords: comparableWords
    };
});
/*
Assign a match value based on normalized words where the most explicit match "exact" is 1000.
Score every word independently and require all of a candidate's meaningful words to match.
 */
function scoreMatch(candidate, modifierNormalized, modifierWords) {
    if (!modifierNormalized || modifierWords.length === 0) {
        return 0;
    }
    var candidateWords = candidate.comparableWords;
    if (candidateWords.length === 0) {
        return 0;
    }
    if (candidate.normalizedKey === modifierNormalized) {
        return 1000;
    }
    var candidateComparableJoined = candidateWords.join(" ");
    var modifierComparableJoined = modifierWords.join(" ");
    if (candidateComparableJoined === modifierComparableJoined) {
        return 980;
    }
    var modifierWordSet = new Set(modifierWords);
    var matchedCandidateWordCount = candidateWords.reduce(function (matchCount, word) {
        return matchCount + (modifierWordSet.has(word) ? 1 : 0);
    }, 0);
    if (matchedCandidateWordCount !== candidateWords.length) {
        return 0;
    }
    var candidateSpecificityScore = candidateWords.length * 100;
    var modifierCoverageScore = (matchedCandidateWordCount / modifierWords.length) * 100;
    return Math.round(candidateSpecificityScore + modifierCoverageScore);
}
/*
Find the best match based on score, but return the generic SVG if we're not confident.
 */
export function resolveToppingImageSrc(modifierLabel) {
    var modifierNormalized = normalizeLabel(modifierLabel || "");
    var modifierWords = toComparableWords(modifierLabel || "");
    var bestMatch = null;
    for (var _i = 0, TOPPING_IMAGE_CANDIDATES_1 = TOPPING_IMAGE_CANDIDATES; _i < TOPPING_IMAGE_CANDIDATES_1.length; _i++) {
        var candidate = TOPPING_IMAGE_CANDIDATES_1[_i];
        var score = scoreMatch(candidate, modifierNormalized, modifierWords);
        if (!bestMatch || score > bestMatch.score) {
            bestMatch = { src: candidate.src, score: score };
        }
    }
    if (!bestMatch || bestMatch.score === 0) {
        return null;
    }
    return bestMatch.src;
}
export function shouldOverlayNoToppingIcon(modifierLabel) {
    var modifierWords = normalizeLabel(modifierLabel || "")
        .split(" ")
        .filter(Boolean);
    return modifierWords.includes("no") && !modifierWords.includes('cheese');
}
